module.exports = __webpack_public_path__ + "static/ufo-c1b535ac0f6df0d5493f175efd1e2454.png";